import { dbAssessments, dbUserAssessments } from 'dbServer/collections';
import { size as _size } from 'lodash-es';



export const fetchAssessments = async () => {
	const assessments = await dbAssessments.getAssessments();
	return !_size(assessments) ? [] : assessments;
};

export const fetchAssessmentDetails = async assessmentId => {
	const assessmentDetails = await dbAssessments.getAssessmentDetails(assessmentId);
	return assessmentDetails || {};
};


export const addUserAssessment = async newUserAssessment => {
	//newUserAssessment.status = SESSION_STATUS.DRAFT;
	const addedUserAssessment = await dbUserAssessments.addUserAssessment(newUserAssessment);
	return addedUserAssessment;
};


